import { keyframes } from '@emotion/react';
export const widthAnimation = (width) => keyframes `
from {
  width: 0;
}
to {
  width: ${width};
}`;
//# sourceMappingURL=index.js.map